import axiosClient, { ApiResponse, axiosCustomError } from "./axiosClient"
import { ILanguage } from "./LanguageService"

export interface IAreaPhotoTranslation {
    areaPhotoId: number | null
    languageId: number
    title: string
    description: string
    language: ILanguage
}

export interface IAreaPhoto {
    id: number | null
    title: string
    photo: string
    orderNumber: number | null
    published: boolean
    areaId: number
    translations: Array<IAreaPhotoTranslation>
}

export default class AreaPhotoService {
    static async listAll(areaId: number) {
        try {
            const { data } = await axiosClient.get<ApiResponse>(`/api/AreaPhotos/${areaId}/All`)

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }

    static async filter(areaId: number, pageIndex: number, pageSize: number, keyword: string) {
        try {
            const { data } = await axiosClient.get<ApiResponse>(`/api/AreaPhotos/${areaId}?keyword=${keyword}&pageSize=${pageSize}&pageIndex=${pageIndex}`)

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }

    static async get(areaId: number, id: number) {
        try {
            const { data } = await axiosClient.get<ApiResponse>(`/api/AreaPhotos/${areaId}/${id}`)

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }

    static async delete(areaId: number, id: number) {
        try {
            const { data } = await axiosClient.delete<ApiResponse>(`/api/AreaPhotos/${areaId}/${id}`, {

            })

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }

    static async update(areaId: number, id: number, formData: FormData) {
        try {
            const { data } = await axiosClient.put<ApiResponse>(`/api/AreaPhotos/${areaId}/${id}`, formData)

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }

    static async create(areaId: number, formData: FormData) {
        try {
            const { data } = await axiosClient.post<ApiResponse>(`/api/AreaPhotos/${areaId}/Create`, formData)

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }

    static async changePublished(areaId: number, id: number) {
        try {
            const { data } = await axiosClient.put<ApiResponse>(`/api/AreaPhotos/${areaId}/ChangePublished/${id}`)

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }
}